module.exports = __webpack_public_path__ + "23f386df9fd2fe0d8f0b9ed10ca048e8.pdf";